import React, { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "./admin_dashboard.css";
import UserCalendar from "../../Calendar/UserCalendar";
import "react-calendar/dist/Calendar.css";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { useState } from "react";
import Api from "../../../Api/axios";
import { Button } from "@mui/material";
import Notice_Board from "../../Notices/Notice_Board";
import Calendar from "react-calendar";
import { Stack } from "react-bootstrap";
import { color } from "@mui/system";
import { Paper, List, ListItem, ListItemText, Avatar } from "@mui/material";
// import {EventIcon} from "@material-ui/icons";
import EventIcon from '@material-ui/icons/Event';
import MessageIcon from '@material-ui/icons/Message';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
function Admin_Dashboard() {
	const [notice, setNotice] = useState([]);
	const [classdata, setClassData] = useState([]);
	const [{ userDetails }, dispatch] = useDataLayerValue();
	const fetchNotices = async () => {
		dispatch({
			type: "SET_LOADING",
			loading: true,
		});
		//console.log("userDetails", userDetails);
		await Api.get("/notices")
			.then((res) => {
				//console.log(res.data);
				let tempNotices = [];
				res.data.forEach((notice) => {
					if (notice.notice_for === userDetails.userType) {
						tempNotices.push(notice);
					}
				});
				setNotice(tempNotices);
				//console.log(notice);
			})
			.catch((err) => console.log(err.response.data.message));
		dispatch({
			type: "SET_LOADING",
			loading: false,
		});
		await Api.get("/live-class").then((res) => setClassData(res.data));
		//console.log("classData", classdata);
		// await Api.get("/count-for-subject").then((res) =>
		//   console.log("attendance ", res)
		// );

		//await Api.get(`user/get-user`).then((res) => console.log("data", res));
	};

	useEffect(() => {
		fetchNotices();
	}, []);
	const [events, setEvents] = useState([{ title: "ok" }, { title: "ok" }, { title: "ok" }, { title: "ok" }, { title: "ok" }, { title: "ok" }]);
	return (
		<div >
			<div className="row" style={{ margin: "1em" }}>
				<div className="col-lg-3 mt-2 mb-2 col-sm-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="horizontal" spacing={2}>
										<div style={{ width: '70%' }}>
											<h2 className="text-black font-w700">9,825</h2>
											<p className="mb-0 text-black font-w600">Total Students</p>
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-end', width: '30%' }}>
											<svg className="primary-icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M57.4998 47.5001C57.4998 48.1631 57.2364 48.799 56.7676 49.2678C56.2987 49.7367 55.6629 50.0001 54.9998 50.0001H24.9998C24.3368 50.0001 23.7009 49.7367 23.2321 49.2678C22.7632 48.799 22.4998 48.1631 22.4998 47.5001C22.4998 43.5218 24.0802 39.7065 26.8932 36.8935C29.7063 34.0804 33.5216 32.5001 37.4998 32.5001H42.4998C46.4781 32.5001 50.2934 34.0804 53.1064 36.8935C55.9195 39.7065 57.4998 43.5218 57.4998 47.5001ZM39.9998 10.0001C38.022 10.0001 36.0886 10.5866 34.4441 11.6854C32.7996 12.7842 31.5179 14.346 30.761 16.1732C30.0041 18.0005 29.8061 20.0112 30.192 21.951C30.5778 23.8908 31.5302 25.6726 32.9288 27.0711C34.3273 28.4697 36.1091 29.4221 38.0489 29.8079C39.9887 30.1938 41.9994 29.9957 43.8267 29.2389C45.6539 28.482 47.2157 27.2003 48.3145 25.5558C49.4133 23.9113 49.9998 21.9779 49.9998 20.0001C49.9998 17.3479 48.9463 14.8044 47.0709 12.929C45.1955 11.0536 42.652 10.0001 39.9998 10.0001ZM17.4998 10.0001C15.522 10.0001 13.5886 10.5866 11.9441 11.6854C10.2996 12.7842 9.0179 14.346 8.26102 16.1732C7.50415 18.0005 7.30611 20.0112 7.69197 21.951C8.07782 23.8908 9.03022 25.6726 10.4287 27.0711C11.8273 28.4697 13.6091 29.4221 15.5489 29.8079C17.4887 30.1938 19.4994 29.9957 21.3267 29.2389C23.1539 28.482 24.7157 27.2003 25.8145 25.5558C26.9133 23.9113 27.4998 21.9779 27.4998 20.0001C27.4998 17.3479 26.4463 14.8044 24.5709 12.929C22.6955 11.0536 20.152 10.0001 17.4998 10.0001ZM17.4998 47.5001C17.4961 44.8741 18.0135 42.2735 19.0219 39.8489C20.0304 37.4242 21.5099 35.2238 23.3748 33.3751C21.8487 32.7989 20.2311 32.5025 18.5998 32.5001H16.3998C12.7153 32.5067 9.18366 33.9733 6.57833 36.5786C3.97301 39.1839 2.50643 42.7156 2.49982 46.4001V47.5001C2.49982 48.1631 2.76321 48.799 3.23205 49.2678C3.70089 49.7367 4.33678 50.0001 4.99982 50.0001H17.9498C17.6588 49.1984 17.5066 48.3529 17.4998 47.5001Z" fill="#1E33F2" />
											</svg>
										</div>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 mt-2 mb-2 col-sm-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="horizontal" spacing={2}>
										<div style={{ width: '70%' }}>
											<h2 className="text-black font-w700">9,825</h2>
											<p className="mb-0 text-black font-w600">Total Teachers</p>
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-end', width: '30%' }}>
											<svg className="primary-icon" width="60" height="60" viewBox="0 0 512 318.97" fill="none" xmlns="http://www.w3.org/2000/svg" >
												<path d="M165.11 35.37c-3.87 0-6.99-3.12-6.99-6.99s3.12-6.99 6.99-6.99h148.37V6.99c0-3.87 3.12-6.99 6.99-6.99s6.99 3.12 6.99 6.99v14.4h176.8c3.87 0 6.99 3.12 6.99 6.99s-3.12 6.99-6.99 6.99h-16.09v200.88h16.84c3.87 0 6.99 3.12 6.99 6.99s-3.12 6.99-6.99 6.99H324.7v7.1c.38.25.63.5.87.75l42.8 40.68c2.74 2.62 2.87 7.11.25 9.85-2.62 2.75-7.11 2.87-9.86.25l-33.93-32.31v35.43c0 3.87-3.12 6.99-6.99 6.99s-6.99-3.12-6.99-6.99v-36.8l-35.43 33.68c-2.75 2.62-7.24 2.62-9.86-.25-2.62-2.74-2.62-7.23.25-9.85l42.8-40.68c.62-.62 1.49-1.12 2.24-1.5v-6.35H163.06c-3.87 0-6.99-3.12-6.99-6.99s3.12-6.99 6.99-6.99h311.13V35.37H165.11zM301.7 206.69a6.4 6.4 0 0 1-6.4-6.4c0-3.53 2.87-6.39 6.4-6.39h136.37c3.53 0 6.39 2.86 6.39 6.39 0 3.54-2.86 6.4-6.39 6.4H301.7zm9.66-42.99c-3.53 0-6.39-2.86-6.39-6.39 0-3.54 2.86-6.4 6.39-6.4h126.71c3.53 0 6.39 2.86 6.39 6.4 0 3.53-2.86 6.39-6.39 6.39H311.36zm-20.78-42.99c-3.53 0-6.39-2.86-6.39-6.39s2.86-6.4 6.39-6.4h147.49c3.53 0 6.39 2.87 6.39 6.4 0 3.53-2.86 6.39-6.39 6.39H290.58zm-65.77-42.99c-3.53 0-6.39-2.86-6.39-6.39s2.86-6.4 6.39-6.4h213.26c3.53 0 6.39 2.87 6.39 6.4 0 3.53-2.86 6.39-6.39 6.39H224.81zm-4.62 84.52 48.49-50.84c2.85-3 7.59-3.11 10.58-.27 3 2.85 3.11 7.59.27 10.58l-45.68 47.9c3.75 4.54 5.53 10.65 4.34 16.88-2.12 11.09-12.83 18.36-23.91 16.24l-50.71-9.75c-5.06-.88-9.8-3.66-13.05-8.15l-16.45-22.73-.04 2.05v-1.48l-1.31 75.84 1.99 11.36H49.66l1.76-10.52-1.56-75.24v.04l-.26-12.9-.09.1c-8.7 8.71-9.07 29.47-10.04 42.08l-2.21 28.88c-.51 6.59-1.06 10.31-6.22 14.77-7.5 6.46-20.13 7.79-26.8-.38-4.31-5.26-4.52-13.66-4.08-21.33 2.22-38.37 6.73-96.12 49.7-115.12v.48c18.22-7.24 39.69-4.09 59.29-4.09 9.33 0 17.53 1.37 24.81 4.16 4.65 1.07 8.94 3.76 11.96 7.93l32.96 45.57 41.31 7.94zM91.77 3.13c23.89 0 43.25 19.36 43.25 43.25 0 23.88-19.36 43.24-43.25 43.24S48.52 70.26 48.52 46.38c0-23.89 19.36-43.25 43.25-43.25z" fill="#1E33F2" />
											</svg>
										</div>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 mt-2 mb-2 col-sm-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="horizontal" spacing={2}>
										<div style={{ width: '70%' }}>
											<h2 className="text-black font-w700">9,825</h2>
											<p className="mb-0 text-black font-w600">Total Parents</p>
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-end', width: '30%' }}>
											<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 16 16" version="1.1">
												<path fill="#1E33F2" d="M9.5 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z" />
												<path fill="#1E33F2" d="M14.27 4h-2.54c0 0 0 0 0 0-0.955 0-1.73 0.775-1.73 1.73v3.27c0 0.552 0.448 1 1 1v6h4v-6c0.552 0 1-0.448 1-1v-3.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z" />
												<path fill="#1E33F2" d="M15 2c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" />
												<path fill="#1E33F2" d="M4.27 5h-2.54c-0.955 0-1.73 0.775-1.73 1.73s0.775 1.73 1.73 1.73c0.955 0 1.73-0.775 1.73-1.73s-0.775-1.73-1.73-1.73c-0.955 0-1.73 0.775-1.73 1.73v2.27c0 0.552 0.448 1 1 1l-1 3h1v3h4v-3h1l-1-3c0.552 0 1-0.448 1-1v-2.27c0-0.955-0.775-1.73-1.73-1.73 0 0 0 0 0 0z" />
												<path fill="#1E33F2" d="M5 3c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z" />
												<path fill="#1E33F2" d="M7 13v3h2v-3c0.552 0 1-0.448 1-1v-1.54c0-0.806-0.654-1.46-1.46-1.46 0 0 0 0 0 0h-1.080c-0.806 0-1.46 0.654-1.46 1.46 0 0 0 0 0 0v1.54c0 0.552 0.448 1 1 1z" />
											</svg>
										</div>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-3 mt-2 mb-2 col-sm-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="horizontal" spacing={2}>
										<div style={{ width: '70%' }}>
											<h2 className="text-black font-w700">9,825</h2>
											<p className="mb-0 text-black font-w600">Total Rooms</p>
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-end', width: '30%' }}>
											<svg width="60" height="60" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512"  >
												<path fill="#1E33F2" d="M486.727,402.549c3.687-5.333,5.853-11.793,5.853-18.753v-29.592c0-18.231-14.832-33.063-33.063-33.063h-11.413     c-19.731,0-35.784,16.053-35.784,35.784v24.149c0,7.814,2.524,15.046,6.791,20.937c-6.152,3.34-11.519,7.941-15.774,13.444     c-4.036-5.219-9.079-9.617-14.837-12.907c3.687-5.333,5.853-11.793,5.853-18.753v-29.592c0-18.231-14.832-33.063-33.063-33.063     H349.88c-4.109,0-8.055,0.705-11.733,1.986v-40.666h26.089c5.762,0,10.435-4.672,10.435-10.435v-52.177     c0-5.763-4.673-10.435-10.435-10.435h-14.61v-45.308c0-31.368-23.985-54.214-59.686-58.488c5.11-8.009,8.03-17.984,8.03-29.17     V58.186c0-28.57-18.981-49.307-45.133-49.307h-6.783c-26.152,0-45.133,20.737-45.133,49.307v18.262     c0,11.186,2.92,21.161,8.03,29.17c-35.7,4.273-59.686,27.12-59.686,58.488v45.308h-14.61c-5.763,0-10.435,4.672-10.435,10.435     v52.177c0,5.764,4.673,10.435,10.435,10.435h26.089v38.68h-7.316c-19.731,0-35.784,16.053-35.784,35.784v24.149     c0,7.814,2.524,15.046,6.791,20.937c-6.152,3.34-11.519,7.941-15.774,13.444c-4.036-5.219-9.079-9.617-14.837-12.907     c3.687-5.333,5.853-11.793,5.853-18.753v-29.592c0-18.231-14.832-33.063-33.063-33.063H55.203     c-19.731,0-35.784,16.053-35.784,35.784v24.149c0,7.814,2.524,15.046,6.791,20.937C10.613,410.48,0,427.007,0,445.969v46.717     c0,5.763,4.673,10.435,10.435,10.435h98.226h98.226h98.226h98.226h98.226c5.762,0,10.435-4.672,10.435-10.435v-46.717     C512,427.394,501.807,411.164,486.727,402.549z M40.289,356.926c0-8.223,6.69-14.913,14.913-14.913h11.413     c6.721,0,12.192,5.469,12.192,12.192v29.592c0,6.721-5.469,12.191-12.192,12.191H55.203c-8.223,0-14.913-6.69-14.913-14.913     V356.926z M98.227,482.251H20.871v-36.282c0-16.052,13.059-29.111,29.111-29.111h19.134c16.052,0,29.111,13.059,29.111,29.111     V482.251z M349.88,342.013h11.413c6.721,0,12.192,5.469,12.192,12.192v29.592c0,6.721-5.469,12.191-12.192,12.191H349.88     c-8.223,0-14.913-6.69-14.913-14.913v-24.149C334.967,348.703,341.657,342.013,349.88,342.013z M221.792,58.186     c0-14.155,7.502-28.437,24.262-28.437h6.783c16.76,0,24.262,14.282,24.262,28.437v18.262c0,14.155-7.502,28.437-24.262,28.437     h-6.783c-16.76,0-24.262-14.282-24.262-28.437V58.186z M263.757,125.756l-14.311,22.482l-14.311-22.482H263.757z      M170.137,164.106c0-22.839,19.107-34.793,40.699-37.658l29.807,46.827c1.915,3.01,5.235,4.832,8.803,4.832     c3.568,0,6.888-1.822,8.803-4.832l29.807-46.827c21.592,2.865,40.699,14.818,40.699,37.658v45.308h-18.262v-26.785     c0-5.763-4.673-10.435-10.435-10.435s-10.435,4.672-10.435,10.435v26.785H209.27v-26.785c0-5.763-4.673-10.435-10.435-10.435     c-5.762,0-10.435,4.672-10.435,10.435v26.785h-18.262V164.106z M145.091,261.591v-31.306h208.709v31.306H145.091z      M138.515,356.926c0-8.223,6.69-14.913,14.913-14.913h11.413c6.721,0,12.192,5.469,12.192,12.192v29.592     c0,6.721-5.469,12.191-12.192,12.191h-11.413c-8.223,0-14.913-6.69-14.913-14.913V356.926z M196.453,482.251h-77.355v-36.282     h-0.001c0-16.052,13.059-29.111,29.111-29.111h19.134c16.052,0,29.111,13.059,29.111,29.111V482.251z M294.678,482.251h-77.355     v-36.282h-0.001c0-16.052,13.059-29.111,29.111-29.111h19.134c16.052,0,29.111,13.059,29.111,29.111V482.251z M236.741,381.075     v-24.149c0-8.223,6.69-14.913,14.913-14.913h11.413c6.721,0,12.192,5.469,12.192,12.192v29.592     c0,6.721-5.469,12.191-12.192,12.191h-11.413C243.431,395.987,236.741,389.297,236.741,381.075z M305.113,415.455     c-4.036-5.219-9.079-9.617-14.837-12.907c3.687-5.332,5.853-11.793,5.853-18.753v-29.592c0-18.231-14.832-33.063-33.063-33.063     h-11.413c-19.731,0-35.784,16.053-35.784,35.784v24.149c0,7.814,2.524,15.046,6.791,20.937     c-6.152,3.34-11.519,7.941-15.774,13.444c-4.036-5.219-9.079-9.617-14.837-12.907c3.687-5.333,5.853-11.793,5.853-18.753v-29.592     c0-12.11-6.549-22.715-16.288-28.474v-43.269h135.662v0v59.745c-2.037,4.494-3.181,9.473-3.181,14.719v24.149     c0,7.814,2.524,15.046,6.791,20.937C314.735,405.352,309.368,409.953,305.113,415.455z M392.904,482.251h-77.355v-36.282h-0.001     c0-16.052,13.059-29.111,29.111-29.111h19.134c16.052,0,29.111,13.059,29.111,29.111V482.251z M433.192,356.926     c0-8.223,6.69-14.913,14.913-14.913h11.413c6.721,0,12.192,5.469,12.192,12.192v29.592c0,6.721-5.469,12.191-12.192,12.191     h-11.413c-8.223,0-14.913-6.69-14.913-14.913V356.926z M491.13,482.251h-0.001h-77.355v-36.282     c0-16.052,13.059-29.111,29.111-29.111h19.134c16.052,0,29.111,13.059,29.111,29.111V482.251z" />
											</svg>
										</div>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row" style={{ margin: "1em" }}>
				<div className="mt-2 mb-2 col-md-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="vertical" spacing={2}>
										<h2 className="text-black font-w700">Upcoming Events</h2>
										<Paper style={{ minHeight: 250, maxHeight: 250, overflow: 'auto' }}>
											<List className="p-2">
												{events.map((event) => (
													<Stack direction="horizontal" spacing={0}>
														<Avatar sx={{ bgcolor: "#fff", color: "#000" }}>
															<EventIcon />
														</Avatar>
														<ListItem button>
															<ListItemText primary={event.title} secondary="Jun 2, 1948 - Jun 2, 1949" />
														</ListItem>
													</Stack>
												))}
											</List>
										</Paper>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="mt-2 mb-2 col-md-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="vertical" spacing={2}>
										<h2 className="text-black font-w700">Notices</h2>
										<Paper style={{ minHeight: 250, maxHeight: 250, overflow: 'auto' }}>
											<List className="p-2">
												{events.map((event) => (
													<ListItem button>
														<ListItemText primary={event.title} secondary="Author / Jun 2, 1948" />
													</ListItem>
												))}
											</List>
										</Paper>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row" style={{ margin: "1em" }}>
				<div className="mt-2 mb-2 col-lg-6">
					<div className="card card-bx" style={{ border: "none" }}>
						<div className="shadow card-body" style={{ borderRadius: 5 }}>
							<div className="media align-items-center">
								<div className="media-body mr-3">
									<Stack direction="vertical" spacing={2}>
										<h2 className="text-black font-w700">Pending Fees</h2>
										<p className="text-black">Total Ammount: $1000</p>
										<Paper style={{ minHeight: 250, maxHeight: 250, overflow: 'auto' }}>
											<List className="p-2">
												{events.map((event) => (
													<Stack direction="horizontal" spacing={0}>
														<Avatar sx={{ bgcolor: "#fff", color: "#000" }}>
																<AccountCircleIcon />
															</Avatar>
															<ListItem button>
																<ListItemText primary={event.title} />
															</ListItem>
														<ListItem
															secondaryAction={
																<ListItem
																	secondaryAction={
																		<ListItemText edge="end" primary="$400" />
																	}
																>
																	
																</ListItem>
															}
														>
															<ListItemText edge="end" primary="8-A" />
														</ListItem>
													</Stack>
												))}
											</List>
										</Paper>
									</Stack>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Admin_Dashboard;
